import { render } from "./ViewMessage.vue?vue&type=template&id=9fbe3bda"
import script from "./ViewMessage.vue?vue&type=script&lang=js"
export * from "./ViewMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__